<template>
  <base-section
    id="program-committee"
  >
    <!---
    <base-section-heading title="Program Committee">
    </base-section-heading>
    --->
    <v-container>
      <base-title
        title="Program Chair"
        size="text-h4"
      />
      <v-row>
        <v-col
          v-for="(program, i) in programs"
          :key="i"
          cols="12"
          md="6"
          style="margin: auto"
        >
          <base-avatar-card
            v-bind="program"
            align="left"
            horizontal
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <base-section
            space="0"
            style="text-align: right"
          >
            We welcome you all to the 28th European Test Symposium ETS 2023 in Venice. The technical program of ETS 2023 addresses many trends and challenges in semiconductor design and manufacturing process covering a range of topics spanning from Analog, Mixed-Signal, RF, DfT, Test Access Standards, Validation, Verification Debug and Diagnosis, Test generation, Fault Simulation, Fault Tolerance, Application, and evaluation. Moreover, we added hot-topics that are now driving semiconductor business: Dependable AI, AI for Testing, Functional Safety and Reliability in Automotive Emerging technologies, Emerging architectures, Security, and Trust. Looking forward to your submissions.
          </base-section>
        </v-col>
      </v-row>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in committeesfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < committeesfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'ProgramCommittee',
    data: () => ({
      isMobile: false,
      programs: [
        {
          title: 'Alberto Bosio',
          src: require('@/images/committees/albertobosio.jpg'),
          text: 'Ecole Central de Lyon, FR',
        },
      ],
      committeesfooter: [
        {
          name: 'Program Chair',
          url: 'program-committee',
        },
        {
          name: 'Topic Chairs',
          url: 'topic-chairs',
        },
        {
          name: 'Program Committee Members',
          url: 'members',
        },
        {
          name: 'Program Committee Companions',
          url: 'companions',
        },
        {
          name: 'Industrial Board',
          url: 'industrial',
        },
        {
          name: 'Organizing Committee',
          url: 'organizing-committee',
        },
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobile () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
